import { Component, Input, OnInit } from '@angular/core';
import { TextQuestionCategory, TextAnswer } from '../../../../models/reporting';

@Component({
  selector: 'app-text-questions-module',
  templateUrl: './text-questions-module.component.html',
  styles: []
})
export class TextQuestionsModuleComponent implements OnInit {
  @Input() textQuestionCategories: Array<TextQuestionCategory> ;

  constructor() {}

  ngOnInit() {

    if (!this.textQuestionCategories) { return; }
    this.textQuestionCategories.forEach(c => this.sortAnswers(c));
  }

  private sortAnswers(c: TextQuestionCategory) {
      if (!c.questions) { return; }
      c.questions.forEach(q => {
          if (q.answers) {
            q.answers.sort(this.answerSorter);
          }
        });
      
  }

  private answerSorter(a: TextAnswer, b: TextAnswer) {
    return (a.isSelfAssesment === b.isSelfAssesment) ? 0 
    : a.isSelfAssesment ? -1 : 1;
  }

}
